:root {
    --uktdd-font-family:
        system-ui, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue,
        Helvetica, Arial, sans-serif;
    --uktdd-body-bg-color: #fff;
    --uktdd-body-bg-color-hover: rgb(105, 162, 249);
    --uktdd-body-color-hover: #fff;
    --uktdd-body-buffer: 10px;
    --uktdd-body-max-height: calc(100dvh - var(--uktdd-body-buffer));
    --uktdd-body-max-width: calc(100dvw - var(--uktdd-body-buffer));
    --uktdd-body-min-height: 30px;
    --uktdd-body-pad-bottom: 9px;
    --uktdd-body-pad-left: 12px;
    --uktdd-body-pad-right: 12px;
    --uktdd-body-pad-top: 9px;
    --uktdd-body-min-width: min(50px, 100%);
    --uktdd-body-position-area: bottom span-right;
    --uktdd-body-position-try-fallbacks:
        --uktdd-top-left, --uktdd-bottom-right, --uktdd-top-right;
    --uktdd-body-translate: 0 0;
    --uktdd-label-pad-right: 10px;
}

.uktdropdown,
.uktdropdown-trigger {
    font-family: var(--uktdd-font-family);
}

.uktdropdown {
    width: max-content;
    anchor-scope: --uktdd-anchor;

    &.disabled {
        pointer-events: none;
    }

    > * {
        cursor: default;
    }

    > :first-child {
        anchor-name: --uktdd-anchor;
    }
}

.uktdropdown-label {
    display: flex;
    align-items: center;
}

.uktdropdown-label-text {
    padding-right: var(--uktdd-label-pad-right);
}

.uktdropdown-body {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: fixed;
    position-anchor: --uktdd-anchor;
    position-area: var(--uktdd-body-position-area);
    position-try-order: most-height;
    position-try-fallbacks: var(--uktdd-body-position-try-fallbacks);
    min-block-size: min(var(--uktdd-body-min-height), var(--uktdd-body-max-height));
    max-block-size: min(var(--uktdd-body-max-height), 100%);
    min-inline-size: min(var(--uktdd-body-min-width), var(--uktdd-body-max-width));
    max-inline-size: var(--uktdd-body-max-width);
    inline-size: max-content;
    overflow: hidden;
    translate: var(--uktdd-body-translate);
    z-index: 2;
    background-color: var(--uktdd-body-bg-color);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.25);

    &.has-items {
        user-select: none;
    }

    [data-ukt-active] {
        background-color: var(--uktdd-body-bg-color-hover);
        color: var(--uktdd-body-color-hover);
    }
}

.uktdropdown-content {
    box-sizing: border-box;
    min-block-size: 0;
    overflow: auto;
    overscroll-behavior: contain;
    padding: var(--uktdd-body-pad-top) var(--uktdd-body-pad-right)
        var(--uktdd-body-pad-bottom) var(--uktdd-body-pad-left);
}

@position-try --uktdd-top-left {
    position-area: top span-right;
}

@position-try --uktdd-bottom-left {
    position-area: bottom span-right;
}

@position-try --uktdd-bottom-right {
    position-area: bottom span-left;
}

@position-try --uktdd-top-right {
    position-area: top span-left;
}
